import { SxProps, Theme } from '@mui/material';
import { atlasSemantic } from 'src/theme/atlas/tokens';

export const label: SxProps<Theme> = {
  color: atlasSemantic.color.type.default,
  fontSize: '12px',
  fontWeight: 600,
  marginBottom: '8px',
};
